import { useState } from 'react'
import useSearchScrollLock from 'src/layout/Header/useSearchScrollLock'
/* Redux */
import Redux from './Drawer.Redux'

/* Material */
import Drawer from '@mui/material/Drawer'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import useStyles from './styles'

/* Components */
import Navigation from './Navigation'
import config from 'src/config'
import Box from '@mui/material/Box'

const NavigationDrawer = () => {
  const classes = useStyles()

  const { open, toggle, searchOpen } = Redux()
  const [root, setRoot] = useState<HTMLDivElement | null>(null)
  const modern = config.mobileMenuVariant === 'modern'
  useSearchScrollLock(open && modern, root)

  return <Drawer ref={setRoot}
    ModalProps={{ disableScrollLock: modern, disableRestoreFocus: searchOpen }}
    className={classes.drawer}
    variant='temporary'
    anchor='left'
    open={open}
    onClose={toggle}
    PaperProps={{ role: 'dialog', 'aria-modal': true, 'aria-label': 'Navigation' }}
    sx={modern ? {
      '&& .MuiDrawer-paper': {
        width: 'min(420px, 100vw)', height: '100dvh', overflow: 'hidden',
        backgroundColor: '#fff', color: config.pageBuilderDefaults?.theme?.textColor || '#252525',
      },
    } : undefined}
  >
    {modern ? <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexShrink: 0 }}>
      <Box component='span' sx={{ pl: 2, fontSize: 17, fontWeight: 700 }}>Entdecken</Box>
      <IconButton autoFocus aria-label='Menü schließen' onClick={toggle} sx={{ ml: 'auto', mr: 1, my: .5 }}>
        <CloseIcon />
      </IconButton>
    </Box> : <IconButton autoFocus aria-label='Menü schließen' onClick={toggle} sx={{ alignSelf: 'flex-end', m: 1 }}>
      <CloseIcon />
    </IconButton>}
    <Navigation placement='drawer' />
  </Drawer>
}

export default NavigationDrawer
